export default __webpack_public_path__ + "static/media/En.789ff1da.png";